var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{attrs:{"id":"dashboard-core-footer"}},[_c('v-container',[_c('span',{staticClass:"body-2 font-weight-light pt-6 pt-md-0"},[_c('center',[_vm._v(" "+_vm._s(_vm.powered_by)+" © "+_vm._s(_vm.year))])],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }